module.exports = __webpack_public_path__ + "img/vet.2bacdb05.jpg";